import React from 'react';
import PropTypes from 'prop-types';
import RpTable from 'rp-react-table';
import columns from './columns';

const Sales = ({ data }) => (
    <section className="hp-sales">
        <RpTable
            data={data.sales}
            columns={columns}
            noDataText="No sales data for this horse"
        />
    </section>
);

Sales.propTypes = {
    data: PropTypes.shape({
        sales: PropTypes.arrayOf(PropTypes.shape({
            abbrevName: PropTypes.string,
            buyerDetail: PropTypes.string,
            curCode: PropTypes.string,
            lotNo: PropTypes.number,
            price: PropTypes.number,
            saleDate: PropTypes.string,
            sellerName: PropTypes.string,
            venueDesc: PropTypes.string,
            venueUid: PropTypes.number,
        })),
    }).isRequired,
};

export default Sales;



// WEBPACK FOOTER //
// ./src/js/horse/sales/Sales.jsx